import { render, staticRenderFns } from "./FeaturedPost.vue?vue&type=template&id=395bae81&"
import script from "./FeaturedPost.vue?vue&type=script&lang=js&"
export * from "./FeaturedPost.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedPost.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports